import { Award, Users, Clock, Shield } from "lucide-react"

function AboutComponent() {
  const stats = [
    { icon: Clock, number: "14+", label: "Yıl Deneyim" },
    { icon: Users, number: "1000+", label: "Mutlu Müşteri" },
    { icon: Award, number: "500+", label: "Tamamlanan İş" },
    { icon: Shield, number: "100%", label: "Müşteri Memnuniyeti" },
  ]

  const services = [
    "Doğal Gaz ve Su Tesisatı",
    "Kaçak Su Tespiti",
    "Kalorifer Tesisatı",
    "Kombi Bakım Onarım",
    "Klima Servisi",
    "Beyaz Eşya Servisi",
    "Kart Tamiri",
    "Yedek Parça Hizmeti",
  ]

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Hakkımızda</h2>
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>Buğra Teknik Servis</strong> olarak 2010 yılında Karabük İlinde kurulduk. Profesyonel ve kendi dalında uzman arkadaşlarımızla Karabük ve İlçelerine sabah 09:00 gece 21:00 arası hizmet vermekteyiz.
                </p>
                <p>
                  Doğal Gaz ve Su Tesisatı, Kaçak Su, Kalorifer Tesisatı, Kombi Bakım Onarım, Klima, Buzdolabı, Çamaşır ve Bulaşık Makinası ve diğer ev aletleri Bakım Onarımı, Kart Tamiri ve Yedek Parça hizmeti vermekteyiz.
                </p>
                <p>
                  İkinci El Ve Sıfır Kombi satışımız da bulunmaktadır. Deneyimli ekibimiz ve kaliteli hizmet anlayışımızla müşterilerimizin güvenini kazanmaya devam ediyoruz.
                </p>
                <p>
                  Karabük ve çevre ilçelerde geniş bir hizmet ağına sahip olan firmamız, müşteri memnuniyeti odaklı çalışma prensibi ile sektörde güvenilir bir marka haline gelmiştir.
                </p>
              </div>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Hizmet Alanlarımız</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {services.map((service, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                    <span className="text-gray-700 text-sm">{service}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Stats and Image */}
          <div className="space-y-8">
            {/* Image */}
            <div className="relative">
              <img
                src="/about.jpg"
                alt="Buğra Teknik Servis Ekibi"
                className="w-full rounded-2xl shadow-lg object-contain"
              />
              <div className="absolute inset-0 bg-blue-600 bg-opacity-10 rounded-2xl"></div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4">
              {stats.map((stat, index) => (
                <div key={index} className="text-center p-6 bg-white rounded-lg shadow-lg">
                  <div className="mx-auto bg-blue-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-3">
                    <stat.icon className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-gray-900">{stat.number}</p>
                    <p className="text-sm text-gray-600">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutComponent
